import { Injectable } from '@angular/core';
import { Broker } from '@c4/core';

@Injectable()
export class ProcessService {

  constructor(private broker: Broker) {}

  // get enable/disable status of processes
  public getProcessStatus = (ip?: string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (error: any) => any) => {

      let request: any = {
          method: 'GET',
          path: '/api/v1/sysman/status' + (ip ? "?ip=" + ip : "")
      };
      this.broker.call(request).then(
          (response: any) => {
              resolve(response);
          },
          (error: any) => {
              reject(error);
          });
      });
  }

  //  enable/disable process
  public toggleProcessStatus = (servicename : string, status: string, ip?: string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (error: any) => any) => {

        var sendPost: any = {};
        if (ip)
          sendPost["ip"] = ip;
        sendPost["service"] = servicename;
        sendPost["enable"] = !(status == 'enabled');
        var request: any = {
          method: 'POST',
          path: '/api/v1/sysman/status',
          data: sendPost
        };
        this.broker.call(request).then(
          (response: any) => {
              resolve(response);
          },
          (error: any) => {
              reject(error);
          });
      });
  }

}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/services/process.service.ts